/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_ListItemGet } from '../models/Model_ListItemGet';
import type { Shared_PictureResolutions } from '../models/Shared_PictureResolutions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ListItemService {
    /**
     * @param id
     * @param resolution
     * @returns Model_ListItemGet Success
     * @throws ApiError
     */
    public static getApiV1ListItem(
        id: ConvertDatesToStrings<string>,
        resolution?: ConvertDatesToStrings<Shared_PictureResolutions>,
    ): CancelablePromise<Array<Model_ListItemGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/list-item/{id}',
            path: {
                'id': id,
            },
            query: {
                'resolution': resolution,
            },
        });
    }
}
